
import { FileText, DollarSign, HelpCircle, Gavel, Send, ClipboardList } from "lucide-react";
import { ProposalSection } from "../types/proposalSection";

// Define proposal sections with icons
export const proposalSections: ProposalSection[] = [
  {
    title: "Summary",
    description: "Create a summary of your RFP/Instructions",
    slug: "summary",
    icon: FileText
  },
  {
    title: "Pricing",
    description: "Define pricing details and options",
    slug: "pricing",
    icon: DollarSign
  },
  {
    title: "Questions",
    description: "Add questions for clients to answer",
    slug: "questions",
    icon: HelpCircle
  },
  {
    title: "Reverse Auction",
    description: "Set up reverse auction options",
    slug: "reverse-auction",
    icon: Gavel
  },
  {
    title: "Review",
    description: "Review all sections of your RFP/Instructions",
    slug: "summary-review",
    icon: ClipboardList
  },
  {
    title: "Invite",
    description: "Invite clients and collaborators to view the RFP/Instructions",
    slug: "invite",
    icon: Send
  }
];
